class ArvouetPopup extends HTMLElement {
  connectedCallback() {
    this.popupId = this.dataset.popupId;
    this.delay = parseInt(this.dataset.delay || '0', 10) * 1000;
    this.cookieDays = parseInt(this.dataset.cookieDays || '0', 10);
    this.cookieKey = `arvouet_popup_${this.popupId}`;

    if (this.cookieDays > 0 && this._getCookie(this.cookieKey)) return;

    this._backdrop = this.querySelector('.arvouet-popup__backdrop');
    this._closeBtn = this.querySelector('.arvouet-popup__close');

    this._backdrop?.addEventListener('click', () => this._close());
    this._closeBtn?.addEventListener('click', () => this._close());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) this._close();
    });

    setTimeout(() => this._open(), this.delay);
  }

  _open() {
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this._closeBtn?.focus();
  }

  _close() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
    if (this.cookieDays > 0) this._setCookie(this.cookieKey, '1', this.cookieDays);
  }

  _setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
  }

  _getCookie(name) {
    return document.cookie.split('; ').some((c) => c.startsWith(name + '='));
  }
}

customElements.define('arvouet-popup', ArvouetPopup);
